import { SortStateDescriptor } from "components/Filters/types";
import { Context } from "types/generated";
import TableSimple from "ds/components/TableSimple";

import useContextsTableStore from "./useContextsTableStore";
import { CONTEXTS_TABLE_CELLS } from "./Cells";
import useContextsAnalytics from "../useContextsAnalytics";
import { ANALYTICS, FILTERS_ORDER_SETTINGS_KEY } from "../constants";
import { CONTEXTS_SORT_CONFIG } from "./constants";

type ContextsTableProps = {
  contexts: Array<Context>;
  loading?: boolean;
  rowsPerPage: number;
  sortCallback: (sortDescriptor: SortStateDescriptor) => void;
};

const ContextsTable = ({ contexts, loading, rowsPerPage, sortCallback }: ContextsTableProps) => {
  const trackAnalytics = useContextsAnalytics();

  return (
    <TableSimple
      data={contexts}
      loading={loading}
      store={useContextsTableStore}
      ariaLabel="Contexts table"
      rowsPerPage={rowsPerPage}
      sortCallback={sortCallback}
      cellPerColumn={CONTEXTS_TABLE_CELLS}
      analyticsPage={ANALYTICS.analyticsPage}
      trackAnalytics={trackAnalytics}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      sortConfig={CONTEXTS_SORT_CONFIG}
    />
  );
};

export default ContextsTable;
